import FrontBusiness from "@/business/FrontBusiness";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";
import LivroMatriculaBusiness from "@/business/livros/LivroMatriculaBusiness";
import TextParser from "@/business/livros/TextParser";
import SimulacaoAtoBusiness from "@/business/protocolo/simulacao/SimulacaoAtoBusiness";
import VueBusiness from "@/business/VueBusiness.js";
import utils from "@/commons/Utils";
import Utils from "@/commons/Utils.js";
import DetalhesIndicadorReal from "@/components/IndicadorReal/Detalhes/DetalhesIndicadorReal";
import ChecklistProcessamentoBusiness from "@/business/ChecklistProcessamentoBusiness";
import AtoBusiness from "@/business/protocolo/AtoBusiness";
import OcorrenciaBusiness from "@/business/ocorrencia/OcorrenciaBusiness";
import TipoServicoBusiness from "@/views/Administracao/modulos/tipo-servico/business";
import AtoLegadoBusiness from "@/business/indicadores/AtoLegadoBusiness";
import DetalhesIndicadorPessoal from "@/components/IndicadorPessoal/Detalhes/DetalhesIndicadorPessoal";
import FracaoTransferenciaImovelBusiness from "@/business/protocolo/FracaoTransferenciaImovelBusiness";
import atoBusiness from "@/business/protocolo/AtoBusiness";
import SimulacaoUtils from "@/business/protocolo/simulacao/SimulacaoUtils";
import PapelBusiness from "@/business/PapelBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";

export default {

  async gerarMinutaLote(protocolo, ficha, atos, documentos = [], ctrl = {}, usuarioLogado = {} ){

    ficha.ctrl = {
      ultimoAto: ficha.ultimoAto,
      status: ficha.status
    }

    for(let i in atos){
      ++ctrl.atual;
      await this.simularAto(atos[i], i, protocolo, ficha, documentos, 'gerar-minuta', null, usuarioLogado);
    }

    return {atos, ficha};

  },

  async gerarMinuta(protocolo, ficha, atos, documentos = [], ctrl = {}, ato, usuarioLogado = {} ){

    ficha.ctrl = {
      ultimoAto: ficha.ultimoAto,
      status: ficha.status
    }

    for(let i in atos){
      ++ctrl.atual;
      if(ato?.id == atos[i]?.id){
        atos[i].templateMinuta = ato.texto;
      }
      await this.simularAto(atos[i], i, protocolo, ficha, documentos, ato?.id == atos[i]?.id ? 'gerar-minuta' : 'processar', null, usuarioLogado);
      if(ato == atos[i]?.id){
        return {atos, ficha};
      }
    }

    return {atos, ficha};

  },

  async simular(protocolo, ficha, atos, documentos = [], ctrl = {}, usuarioLogado= {}){

    ficha.ctrl = {
      ultimoAto: ficha.ultimoAto,
      status: ficha.status
    }

    const root = VueBusiness.getVueRoot();
    let atosNaoPermitemRegistroComIndisponibilidade = atos.filter(a => !a?.tipoServico?.opcoes?.registroIndisponibilidade);
    let atosNaoPermitemRegistroComOcorrencia = atos.filter(a => !a?.tipoServico?.opcoes?.registroOcorrencia);

    // Verificação de permissões
    let existePermissaoDefinida = (root.usuarioLogado?.permissao || []).length;
    let isGestor = root.usuarioLogado.gestor;
    let gestorNaoDeveSolicitarPermissao = root.config?.indisponibilidade?.registroIndisponibilidadeGestor === false;
    let autorizado = root.getPermission({id: 'PERMITIR_REGISTRAR_PROTOCOLO_INDISPONIBILIDADE_SEM_PERMISSAO', dominio: protocolo?.dominio || 'PROTOCOLO_RI'});

    let podeRegistrarComIndispOcorr = !existePermissaoDefinida ? (isGestor && gestorNaoDeveSolicitarPermissao) : autorizado;

    if (root.config.geral.usarGrupoPermissaoCompleto) {
      podeRegistrarComIndispOcorr = autorizado;
    }

    let extras = {
      permiteRegistroComIndisponibilidade: podeRegistrarComIndispOcorr || atosNaoPermitemRegistroComIndisponibilidade.length === 0,
      permiteRegistroComOcorrencia: podeRegistrarComIndispOcorr || atosNaoPermitemRegistroComOcorrencia.length === 0,
    }

    for(let i in atos){
      ++ctrl.atual;
      await this.simularAto(atos[i], i, protocolo, ficha, documentos, 'completo', extras, usuarioLogado);
    }

    return {atos, ficha};

  },

  isTipoRegistroMeuOrMunicipio(ato) {
    return ['MEU', 'MUNICIPIO'].includes(ato.tipoRegistro);
  },

  async simularAto(ato, posicao, protocolo, ficha, documentos = [], modo = 'completo', extras = {}, usuarioLogado){
    ato = await SimulacaoUtils.tratarPrenotacao({ato, protocoloId: protocolo?.id})
    ato.envolvidos = ato.envolvidos || [];

    let simulacaoCompleta = modo == 'completo';
    const trataFracao = (valor) => parseFloat(parseFloat(valor).toFixed(10));

    let promises = [], envolvidosPromise = [];

    ato.erros = [];
    ficha.alertas = [];

    if(ficha.status == 'PENDENTE'){
      ficha.prematricula = true;
    }

    const criarErro = (msg, area = '', tipo = 'erro', command, tipoErro) => {
      if(simulacaoCompleta){
        ato.erros.push({area, msg, tipo, command, tipoErro});
      }
    };

    if(!ato.tipoServico?.opcoes){
      criarErro("Necessário configurar o tipo de ato", null, 'erro');
      console.error("Necessário configurar o tipo de ato");
      return;
    }

    if(posicao == 0 && simulacaoCompleta){

      let ocorrenciaBloqueante = false;
      let ocorrenciasIndicadorReal = await OcorrenciaBusiness.listarPorIndicadorReal(ficha.id);

      for (let i = 0; i < ocorrenciasIndicadorReal.length; i++) {
        if (ocorrenciasIndicadorReal[i].ocorrencia_bloqueante === "true") {
          ocorrenciaBloqueante = true;
        }
      }
      if(ato.envolvidos.length > 0){
        for (let i = 0; i < ato.envolvidos.length; i++) {
          let ocorrenciaEnvolvido = await OcorrenciaBusiness.listarPorEnvolvido(ato.envolvidos[i].indicadorPessoalId);
          if (ocorrenciaEnvolvido.ocorrencia_bloqueante === "true") {
            ocorrenciaBloqueante = true;
          }
        }
      }

      const ocorrenciasAtivasPromise = OcorrenciaBusiness.indicadorRealPossuiOcorrenciasAtivas(ficha.id).then(ocorrenciasAtivas => {
        if(ocorrenciasAtivas){
          let permiteRegistro = !ocorrenciaBloqueante || extras.permiteRegistroComOcorrencia;
          const erroOuWarning = protocolo.dataConsentimentoRegistro || permiteRegistro ? 'warning' : 'erro';
          criarErro(FrontBusiness.nomearFicha(ficha)+" possui ocorrências",  '', erroOuWarning, () => {
            FrontBusiness.openModal(DetalhesIndicadorReal, {id: ficha.id, abaInicial: 'ocorrencias'});
          }, 'OCORRENCIA');
        }
      });
      promises.push(ocorrenciasAtivasPromise);
      let possuiIndisponibilidades = await IndicadorRealBusiness.possuiIndisponibilidades(ficha.id);
      if (possuiIndisponibilidades) {
        const erroOuWarning = protocolo.dataConsentimentoRegistro || extras.permiteRegistroComIndisponibilidade ? 'warning' : 'erro';
        criarErro("Matrícula possui indisponibilidade", '', erroOuWarning, () => {
          FrontBusiness.openModal(DetalhesIndicadorReal, {id: ficha.id, abaInicial: 'indisponibilidades'});
        }, 'INDISPONIBILIDADE');
      }

    }

    const motivoIsencao= VueBusiness.getVueRoot().isEstadoCE ? ato.ressarcimento?.motivo : ato.ressarcimento?.motivoIsencao;

    if ((ato.isento || this.isTipoRegistroMeuOrMunicipio(ato)) && VueBusiness.getVueRoot().isEstadoRS) {
      if (Utils.isEmptyNullOrUndefined(ato.ressarcimento?.tipoIsencao) || Utils.isEmptyNullOrUndefined(ato.ressarcimento?.motivoIsencao)) {
        criarErro(`Os campos “Tipo de Isenção” e/ou “Motivos de Isenção” não foram preenchidos.`, null,  'erro');
      }
    }

    if (ato.dto.processamentoEletronicoIsento && VueBusiness.getVueRoot().isEstadoRS) {
      if (Utils.isEmptyNullOrUndefined(ato.ressarcimento?.tipoIsencaoProcessamentoEletronico) || Utils.isEmptyNullOrUndefined(ato.ressarcimento?.motivoIsencaoProcessamentoEletronico)) {
        criarErro(`Os campos “Tipo de Isenção” e/ou “Motivos de Isenção” não foram preenchidos para o Processamento Eletrônico.`, null,  'erro');
      }
    }

    if(ato.isento && (Utils.isEmptyNullOrUndefined(motivoIsencao))){
      if(VueBusiness.getVueRoot().isEstadoSC){
        if(Utils.isEmptyNullOrUndefined(ato.ressarcimento?.tipoProcesso) || (ato.ressarcimento?.tipoProcesso != 'NAO_RESSARCIVEL' && Utils.isEmptyNullOrUndefined(ato.ressarcimento?.numeroProcesso))){
          criarErro(`Necessário preencher os dados de ressarcimento.`, null,  'erro');
        }
      }

      if(VueBusiness.getVueRoot().isEstadoMG || VueBusiness.getVueRoot().isEstadoCE){
        criarErro(`Necessário preencher os dados de ressarcimento.`, null,  VueBusiness.getVueRoot().isEstadoMG ? 'erro' : 'alerta');
      }
    }

    if (VueBusiness.getVueRoot().isEstadoPE) {
      if (Utils.isEmptyNullOrUndefined(ato.guia)){
        criarErro(`Necessário informar o número da Guia SICASE`, null,  'erro');
      }
    }

    const documentosEnvolvidos = [];

    ficha.proprietarios.forEach(proprietario => {
      ato.envolvidos?.forEach((envolvido) => {
        const versaoDoProprietario = proprietario.indicadorPessoalVersao;
        if(versaoDoProprietario && versaoDoProprietario.documento === envolvido.documento && versaoDoProprietario.indicadorPessoalId !== envolvido.indicadorPessoalId && !Utils.isEmptyNullOrUndefined(envolvido.documento)){
          criarErro(`O proprietário (${versaoDoProprietario.nome}) possui o mesmo ${envolvido.tipoPessoa === 'FISICA' ? 'CPF' : 'CNPJ'} que o envolvido (${envolvido.nome}) porém são indicadores diferentes`, null,  'warning',);
        }
      });
    });

   await atoBusiness.validarAto(protocolo.id,ato.livro, ato.id, simulacaoCompleta, modo).then(alertas=>{
      alertas.map(a=>{
        criarErro(a.message,a.area, a.tipo);
      });
    });

    const hasLivro2 = ['MATRICULA', 'TRANSCRICAO'].includes(ato.livro);
    const hasLivro3 = ato.livro === 'REGISTRO_AUXILIAR';

    if (hasLivro2) {
      const tsOpcoes = ato?.tipoServico?.opcoes;

      const itn003Valor = ato.classificacaoAtoItn003;
      const itn003Vazio = !itn003Valor;
      // Modo ausente = Variável (padrão): só o 'FIXA' explícito compara com o valor fixo.
      const itn003Modo = tsOpcoes?.classificacaoAtoItn003Modo;
      const itn003Fixa = tsOpcoes?.classificacaoAtoItn003;
      // Fixa apontando para "Nenhum" (ou sem valor) = o tipo de serviço declara que este ato não tem
      // classificação ITN 003. Não é pendência: o campo nem aparece no ato, então não há o que cobrar.
      const itn003SemClassificacaoConfigurada = itn003Modo === 'FIXA' && (!itn003Fixa || itn003Fixa === 'NENHUM');
      let itn003Incompativel = false;
      if (!itn003Vazio) {
        if (itn003Modo !== 'FIXA') {
          const itn003Disponiveis = tsOpcoes?.classificacaoAtoItn003OpcoesDisponiveis || [];
          // Lista de opções em branco = sem restrição: qualquer classificação é válida.
          itn003Incompativel = itn003Disponiveis.length > 0 && !itn003Disponiveis.includes(itn003Valor);
        } else if (itn003Fixa) {
          itn003Incompativel = itn003Valor !== itn003Fixa;
        }
      }
      if (!itn003SemClassificacaoConfigurada && (itn003Vazio || itn003Incompativel)) {
        criarErro('Necessário preencher o campo "Classificação Ato - ITN 003" no indicador real para prosseguir com o registro e envio ao ONR', 'informacoes-regulatorias', 'warning');
      }

      if (ato.classificacaoAtoItn003 === 'TRANSMISSAO_AQUISICAO_ORIGINARIA' && !ato.transmissaoAquisicaoOriginaria) {
        criarErro('Necessário preencher o campo "Transmissão/Aquisição Originária de Direitos Reais" no indicador real para prosseguir com o registro e envio ao ONR', 'informacoes-regulatorias', 'warning');
      }

      const itn004Livro2Valor = ato.classificacaoAtoItn004Livro2;
      const itn004Livro2Vazio = !itn004Livro2Valor;
      let itn004Livro2Incompativel = false;
      if (!itn004Livro2Vazio) {
        const itn004Livro2Modo = tsOpcoes?.classificacaoAtoItn004Livro2Modo;
        // Modo ausente = Variável (padrão): só o 'FIXA' explícito compara com o valor fixo.
        if (itn004Livro2Modo !== 'FIXA') {
          const itn004Livro2Disponiveis = tsOpcoes?.classificacaoAtoItn004Livro2OpcoesDisponiveis || [];
          // Lista de opções em branco = sem restrição: qualquer classificação é válida.
          itn004Livro2Incompativel = itn004Livro2Disponiveis.length > 0 && !itn004Livro2Disponiveis.includes(itn004Livro2Valor);
        } else if (tsOpcoes?.classificacaoAtoItn004Livro2) {
          itn004Livro2Incompativel = itn004Livro2Valor !== tsOpcoes.classificacaoAtoItn004Livro2;
        }
      }
      if (itn004Livro2Vazio || itn004Livro2Incompativel) {
        criarErro('Necessário preencher o campo "Classificação Ato Livro 2 – ITN 004" para classificar o ato conforme a ITN 004', 'informacoes-regulatorias', 'warning');
      }
    }

    if (hasLivro3) {
      const tsOpcoes = ato?.tipoServico?.opcoes;
      const itn004Livro3Valor = ato.classificacaoAtoItn004Livro3;
      const itn004Livro3Vazio = !itn004Livro3Valor;
      let itn004Livro3Incompativel = false;
      if (!itn004Livro3Vazio) {
        const itn004Livro3Modo = tsOpcoes?.classificacaoAtoItn004Livro3Modo;
        // Modo ausente = Variável (padrão): só o 'FIXA' explícito compara com o valor fixo.
        if (itn004Livro3Modo !== 'FIXA') {
          const itn004Livro3Disponiveis = tsOpcoes?.classificacaoAtoItn004Livro3OpcoesDisponiveis || [];
          // Lista de opções em branco = sem restrição: qualquer classificação é válida.
          itn004Livro3Incompativel = itn004Livro3Disponiveis.length > 0 && !itn004Livro3Disponiveis.includes(itn004Livro3Valor);
        } else if (tsOpcoes?.classificacaoAtoItn004Livro3) {
          itn004Livro3Incompativel = itn004Livro3Valor !== tsOpcoes.classificacaoAtoItn004Livro3;
        }
      }
      if (itn004Livro3Vazio || itn004Livro3Incompativel) {
        criarErro('Necessário preencher o campo "Classificação Ato Livro 3 – ITN 004" para classificar o ato conforme a ITN 004', 'informacoes-regulatorias', 'warning');
      }
    }

    for(let envolvido of ato.envolvidos){

      if(!ato?.tipoServico?.opcoes?.registroIndisponibilidade){ // "Permitir registro com indisponibilidade: Não"
        if(simulacaoCompleta && ['TRANSMITENTE', 'CEDENTE', 'PROMITENTE_VENDEDOR', 'ADQUIRENTE', 'CESSIONARIO',  'PROMITENTE_COMPRADOR'].includes(envolvido.papel)){
          let promise = IndicadorPessoalBusiness.possuiIndisponibilidades(envolvido.indicadorPessoalId);
          promises.push(promise);
          promise.then(possuiIndisponibilidade => {
            if(possuiIndisponibilidade){
              const erroOuWarning = protocolo.dataConsentimentoRegistro || extras.permiteRegistroComIndisponibilidade ? 'warning' : 'erro';
              criarErro(`O envolvido ${envolvido.nome} [${envolvido.documento}] possui indisponibilidades abertas`, 'envolvidos', erroOuWarning, () => {
                FrontBusiness.openModal(DetalhesIndicadorPessoal, {versao: envolvido.indicadorPessoalVersaoId, abaInicial: 'indisponibilidades'});
              }, 'INDISPONIBILIDADE');
            }
          });
        }
      }

      if(simulacaoCompleta || modo == 'gerar-minuta'){
        let p = IndicadorPessoalBusiness.getVersaoByIdComCache(envolvido.indicadorPessoalVersaoId);
        envolvidosPromise.push(p);

        p.then( async pessoa => {

          envolvido.indicadorPessoalVersao = pessoa;

          if(documentosEnvolvidos.includes(envolvido.documento) && !Utils.isEmptyNullOrUndefined(envolvido.documento)){
            criarErro(`Há envolvidos com o mesmo ${envolvido.tipoPessoa === 'FISICA' ? 'CPF' : 'CNPJ'} (${envolvido.documento})`, null,  'warning');
          }

          documentosEnvolvidos.push(envolvido.documento);

          if(VueBusiness.getVueRoot().isEstadoSC){
            let campos = IndicadorPessoalBusiness.validarEndereco(pessoa);
            if(campos?.length){
              criarErro(`O endereço do envolvido ${envolvido.nome} está incompleto: ${FrontBusiness.formatArray(campos)}`, '', 'warning');
            }
          }

        });
      }

    }

    if(envolvidosPromise.length){
      await Promise.all(envolvidosPromise);
    }

    // Atualiza ato (para minuta e demais ações)
    ato.ficha = utils.clone(ficha);
    ato.codigo = (ficha.status == 'PENDENTE' || (ato.tipo || ato.tipoServico?.opcoes?.tipoAto) === 'ABERTURA') ? 0 : (parseInt(ficha.ultimoAto || 0,10) + 1);

    let tipo = ato.tipoServico?.opcoes?.tipoAto == 'REGISTRO' ? 'R.' : 'Av.';
    ato.codigoStr = ato.tipoServico?.opcoes?.tipoAto == 'ABERTURA' ? 'M.0' : tipo + ato.codigo;
    ficha.ultimoAto = ato.codigo;

    // Verifica exigência
    let isExigencias = false;
    if (simulacaoCompleta && ato?.exigencias?.length) {
      isExigencias = true;
    }

    if (simulacaoCompleta && ato?.envolvidos?.length) {
      (ato?.envolvidos || []).forEach(envolvido => {
        if (envolvido?.exigencias?.length) {
          isExigencias = true;
        }
      })
    }

    if (isExigencias) {
      criarErro("O ato possui exigências", 'exigencia', 'erro');
    }

    if (simulacaoCompleta && !ato?.indices?.respondidos || ato?.indices?.respondidos < ato?.indices?.quantidade) {

      if(!ato.legado){
        // INÍCIO: Montar Contador por Grupo de Checklist
        const item = await AtoBusiness.getById(protocolo.id, ato.id);

        const vinculos = {documentos};
        if (item.envolvidos) {
          vinculos.envolvidos = item.envolvidos;
        }
        if (item.indicadorReal) {
          vinculos.matricula = item.indicadorReal;
        }

        const resultados = await ChecklistProcessamentoBusiness.contarChecklistsDoAto(item, vinculos);

          // Exibição ato relatório de indicador real
        if((JSON.stringify(item.dto.indicador) == '{}' && JSON.stringify(item.dto.incluirAtoRelatorioIR) == 'true' && item.tipoServico?.opcoes?.incluirRelatorioIR) || (!item.tipoServico?.opcoes?.opcionalIncluirRelatorioIR &&  item.tipoServico?.opcoes?.incluirRelatorioIR && JSON.stringify(item.dto.indicador) == '{}')){
          criarErro('Este ato deve ser incluído no relatório de Indicador Real, mas não houve alteração do indicador real.', '', 'alerta')
        }

        for(let checklist of (resultados || [])){
          if(checklist.contador.quantidade > 0 && checklist.contador.respondidos < checklist.contador.quantidade){
            let msgErro = 'Checklist está incompleto: ';
            let titulo = checklist.titulo || checklist.nome;
            let area = `checklist-${checklist.id}.checklist-group .nao-respondido`;
            if(VueBusiness.getVueRoot().getPermission({id: 'PERMITIR_REGISTRAR_CHECKLIST_INCOMPLETO_PROTOCOLO', dominio: protocolo?.dominio || 'PROTOCOLO_RI'})){
              criarErro(msgErro + titulo, area, 'alerta');
            }else{
              criarErro(msgErro + titulo, area, 'erro');
            }
          }
        }

      }

    }

    // ENCERRAMENTO DE MATRÍCULA
    if(['CANCELAMENTO', 'ENCERRAMENTO'].includes(ato.tipoServico?.opcoes?.operacaoIndicadorReal)){
      let msg = `Este ato ${ato.tipoServico?.opcoes?.operacaoIndicadorReal == 'CANCELAMENTO' ? 'cancelará' : 'encerrará'} a ${ficha.status == 'PENDENTE' || ficha.prematricula? 'pré-' : ''}${FrontBusiness.nomearLivro(ficha.livro).toLowerCase()}.`
      criarErro(msg, null,  'warning');
      ficha.status = ato.tipoServico?.opcoes?.operacaoIndicadorReal == 'CANCELAMENTO' ? 'CANCELADA' : 'ENCERRADA';
    }

    // Gerar minuta
    if(simulacaoCompleta || modo == 'gerar-minuta'){

      if((modo == 'gerar-minuta' || !ato?.tipoServico?.opcoes?.editarMinuta)){

        let atoPromise = LivroMatriculaBusiness.gerarMinutaAto(ato, ficha, protocolo, documentos, usuarioLogado);
        atoPromise.then(minuta => {
          ato.minuta = minuta;

          const minutaInvalida = TextParser.minutaInvalida(ato.minuta);
          if(minutaInvalida){
            criarErro(minutaInvalida, 'minuta', 'erro');
          }

        });

        promises.push(atoPromise);

      }else {
        ato.minuta = ato.texto;
        const minutaInvalida = TextParser.minutaInvalida(ato.minuta);
        if(minutaInvalida){
          criarErro(minutaInvalida, 'minuta', 'erro');
        }
      }

    }

    // Necessário encerrar as promessas antes de seguir com as transformações
    await Promise.all(promises);

    // ABERTURA DE MATRÍCULA - DEVE SEMPRE SER APÓS A GERAÇÃO DA MINUTA
    if(ficha.status == 'PENDENTE'){
      if(ato.tipoServico.opcoes.tipoAto != 'ABERTURA'){
        const permitirRegistroPreMatricula = VueBusiness.getVueRoot()?.config?.indicadorReal?.permitirRegistroPreMatricula;
        if (!permitirRegistroPreMatricula) {
          criarErro('O primeiro ato deve ser um ato de abertura', '', 'erro');
        }
      }else{
        ficha.status = 'ABERTA';
      }
    }

    // REATIVAR
    if (!['CANCELADA', 'ENCERRADA', 'ANULADA', 'BLOQUEADA'].includes(ficha.status) && ato.tipoServico.opcoes.operacao == 'REATIVAR') {
      criarErro('Só é possível reativar matrículas canceladas, encerradas, anuladas ou bloqueadas', '', 'erro');
    }else if (ato.tipoServico.opcoes.operacao == 'REATIVAR') {
      ficha.status = 'ABERTA';
    }

    if(simulacaoCompleta){
      // Verifica erros no cálculo de custa
      if(ato.custas?.erro){
        criarErro(ato.custas.erro?.descricao || ato.custas.erro, '', 'erro');
      }

      // Erro com envolvidos
      let envolvidos = ato.envolvidos.map(e => `${e.papel}-${e.indicadorPessoalVersao.indicadorPessoalId}`);

      let duplicados = [];

      if(envolvidos.length != Array.from(new Set(envolvidos)).length){
        ato.envolvidos.forEach(envolvidoOuter => {
          ato.envolvidos.forEach(envolvidoInner => {
            if(ato.envolvidos.indexOf(envolvidoOuter) != ato.envolvidos.indexOf(envolvidoInner) && envolvidoOuter.nome == envolvidoInner.nome) {
              if(!duplicados.includes(envolvidoOuter.nome) && envolvidoInner.papel == envolvidoOuter.papel) {
                criarErro(envolvidoOuter.nome + " está informado(a) duas vezes com o mesmo papel.", 'envolvidos', 'erro');
                duplicados.push(envolvidoOuter.nome);
              }
            }
          })
        })
      }

      if(ato.tipoServico?.opcoes?.envolvidosSemHashCNIB == false && ato.envolvidos.find(e => Utils.isEmptyNullOrUndefined(e.consultaCnib))){
        criarErro("Necessário informar hash da consulta CNIB das partes envolvidas", 'envolvidos', 'erro');
      }

      SimulacaoUtils.validarBibEnvolvidos(ato, criarErro);

      const quantidadePartesSemDocumento = ato.envolvidos.filter(e => !e.indicadorPessoalVersao.documento || !e.indicadorPessoalVersao.nome).length;
      if(quantidadePartesSemDocumento > 0){
        criarErro(`Existe ${quantidadePartesSemDocumento > 1 ? 'mais de uma' : 'uma'} parte envolvida sem CPF/CNPJ`, 'envolvidos', 'warning');
      }

      (ato.tipoServico.opcoes.papeisObrigatorios || []).forEach(papel => {
        if(!ato.envolvidos.find(e => e.papel == papel)){
          criarErro(`Necessário informar uma parte envolvida como ${TipoServicoBusiness.nomePapel(papel)}`, 'envolvidos', 'erro');
        }
      });

      if(ato.tipoServico.opcoes.restricaoOpcional){
        const restricoesBase = ['ONUS', 'ACAO', 'INDISPONIBILIDADE'].filter(r => ato.dto?.configuracaoRestricao?.restricoesSelecionadas?.includes(r));
        if (restricoesBase.length > 0) {
          const papeis_obrigatorios = [...new Set(restricoesBase.flatMap(r => PapelBusiness.papeisPorRestricao(r)))];
          const pObrigatorios1 = ato.tipoServico.opcoes.papeisObrigatorios.find(p => papeis_obrigatorios.includes(p));
          if(!pObrigatorios1 && !ato.envolvidos.find(e => papeis_obrigatorios.includes(e.papel))){
            let nomes = papeis_obrigatorios.map(p => PapelBusiness.getNomePapel(p)).join(', ');
            criarErro(`Necessário informar uma parte envolvida como ${nomes} para a criação da restrição`, 'envolvidos', 'erro');
          }
        }

        const papeisCompromisso = PapelBusiness.papeisPorRestricao('COMPROMISSO');
        const c2 = ato.dto?.configuracaoRestricao?.restricoesSelecionadas?.includes('COMPROMISSO');
        const pObrigatorios2 = ato.tipoServico.opcoes.papeisObrigatorios?.find(p => papeisCompromisso.includes(p));
        if(c2 && !pObrigatorios2 && !ato.envolvidos.find(e => papeisCompromisso.includes(e.papel))){
          let nomes = papeisCompromisso.map(p => PapelBusiness.getNomePapel(p)).join(' ou ');
          criarErro(`Necessário informar uma parte envolvida como ${nomes} para a criação da restrição`, 'envolvidos', 'erro');
        }

        const papeisDominio = PapelBusiness.papeisPorRestricao('DOMINIO');
        const c3 = ato.dto?.configuracaoRestricao?.restricoesSelecionadas?.includes('DOMINIO');
        const pObrigatorios3 = ato.tipoServico.opcoes.papeisObrigatorios?.find(p => papeisDominio.includes(p));
        if(c3 && !pObrigatorios3 && !ato.envolvidos.find(e => papeisDominio.includes(e.papel))){
          let nomes = papeisDominio.map(p => PapelBusiness.getNomePapel(p)).join(', ');
          criarErro(`Necessário informar uma parte envolvida como ${nomes} para a criação da restrição`, 'envolvidos', 'erro');
        }
      }
    }

    // Necessário verificar o percentual de aquisição da propriedade.
    if (ato.tipoServico.opcoes.alterarProprietarios) {
      let adquirenteZerado = 0;
      (ato.envolvidos || []).forEach((p, i) => {
        let fracao = parseFloat(p.fracao || 0);
        if (AtoLegadoBusiness.getPapeisAdquirente().includes(p.papel) && fracao <= 0) {
          adquirenteZerado += 1;
        }
      })
      if (adquirenteZerado > 0) {
        criarErro(`Necessário verificar o percentual de aquisição da propriedade.`, 'envolvidos', 'erro');
      }
    }

    // Altera proprietários e normaliza proprietários na ficha
    if (ato.tipoServico.opcoes.alterarProprietarios) {

      let proprietarios = {}, proprietariosArea = {};
      let pessoas = {};
      (ficha.proprietarios || []).forEach(p => {
        proprietarios[p.indicadorPessoalVersao.indicadorPessoalId] = p.fracao;
        proprietariosArea[p.indicadorPessoalVersao.indicadorPessoalId] = p.area;
        pessoas[p.indicadorPessoalVersao.indicadorPessoalId] = {
          nome: p.indicadorPessoalVersao.nome,
          documento: p.indicadorPessoalVersao.documento
        };
      });

      (ato.envolvidos || []).forEach((p, i) => {

        let idIndicadorPessoalOriginal = p.indicadorPessoalId;
        pessoas[idIndicadorPessoalOriginal] = { nome: p.nome, documento: p.documento, indicadorPessoalId : p.indicadorPessoalId, id : p.indicadorPessoalVersaoId };

        let fracaoAtual = parseFloat(proprietarios[idIndicadorPessoalOriginal] || 0);
        let fracaoInformada = parseFloat(p.fracao || 0);

        let areaAtual = parseFloat(proprietariosArea[idIndicadorPessoalOriginal] || 0);
        let areaInformada = parseFloat(p.area || 0);

        if (p.papel == 'ADQUIRENTE') {
          proprietarios[idIndicadorPessoalOriginal] = trataFracao(fracaoAtual + fracaoInformada);
          proprietariosArea[idIndicadorPessoalOriginal] = trataFracao(areaAtual + areaInformada);
        }

        if (p.papel == 'TRANSMITENTE') {

          if (fracaoInformada > fracaoAtual) {
            criarErro(`${p.nome} não possui fração suficiente para transmitir`, 'envolvidos', 'erro');
          } else {
            proprietarios[idIndicadorPessoalOriginal] = trataFracao(fracaoAtual - fracaoInformada);
            if (proprietarios[idIndicadorPessoalOriginal] <= 0) {
              delete proprietarios[idIndicadorPessoalOriginal];
            }
          }

          if (areaInformada > areaAtual) {
            //criarErro(`${p.nome} não possui fração (${unidadeArea}) suficiente para transmitir`, 'envolvidos', 'erro');
          } else {
            proprietariosArea[idIndicadorPessoalOriginal] = trataFracao(areaAtual - areaInformada);
            if (proprietariosArea[idIndicadorPessoalOriginal] <= 0) {
              delete proprietariosArea[idIndicadorPessoalOriginal];
            }
          }

        }

      });

      let somaFracao = Object.values(proprietarios).reduce((accum, curr) => (parseFloat(accum) + parseFloat(curr)).toFixed(10), 0);
      let somaArea = Object.values(proprietariosArea).reduce((accum, curr) => (parseFloat(accum) + parseFloat(curr)).toFixed(10), 0);

      if(simulacaoCompleta){
        const erro = await FracaoTransferenciaImovelBusiness.validarMargemTransferenciaRegistro(somaFracao);
        if(erro){
          criarErro(erro.mensagem, 'envolvidos', erro.tipo);
        }

        if (ficha.area && somaArea && (somaArea < (ficha.area - 0.5) || somaArea > (ficha.area + 0.5))) {
          //criarErro(`A soma das frações em ${unidadeArea} dos adquirentes está diferente da soma das frações em ${unidadeArea} dos proprietários`, 'envolvidos', 'erro');
        }
      }

      ficha.proprietarios = Object.keys(proprietarios).map(id => {
        return {indicadorPessoalVersao : {...pessoas[id], indicadorPessoalId : id}, fracao: parseFloat(proprietarios[id]).toFixed(10), area: parseFloat(proprietariosArea[id]).toFixed(10)};
      });

    }

    if (ato.tipoServico.opcoes.tipoTransacaoDoi !== 'NENHUM') {
      let adquirente = 0;
      let transmitente = 0;
      (ato.envolvidos || []).forEach((p, i) => {
        let fracao = parseFloat(p.fracao || 0);
        if (['PROMITENTE_COMPRADOR', 'CESSIONARIO'].includes(p.papel)) {
          adquirente += trataFracao(fracao);
        }
        if (['PROMITENTE_VENDEDOR', 'CEDENTE'].includes(p.papel)) {
          transmitente += trataFracao(fracao);
        }
      });
      let diferente = FrontBusiness.formatNumber(adquirente, 2, 10) !== FrontBusiness.formatNumber(transmitente, 2, 10);
      if (transmitente + adquirente > 0 && diferente) {
        criarErro(`A somatória das frações dos envolvidos com os papeis Promitente Transmitente e Cedente não está de acordo com a somatória dos envolvidos com os papeis Promitente Adquirente e Cessionário.`, 'envolvidos', 'erro');
      }
      if (transmitente > 100.50) {
        criarErro(`A somatória das frações dos envolvidos com os papeis Promitente Transmitente e Cedente está ultrapassando o total permitido: 100,50%`, 'envolvidos', 'erro');
      }
    }

    // Altera indicador real
    if (ato.tipoServico.opcoes.editarIndicador || ato.tipoServico.opcoes.editarIndicadorReal) {
      Object.keys(ato.dto.indicador || {}).forEach(k => ficha[k] = ato.dto.indicador[k]);
    }

    if(simulacaoCompleta){

      // if (Utils.isEmptyNullOrUndefined(ficha.imovelUniao)) {
      //   criarErro(`IMÓVEL DA UNIÃO [DOITU]: O campo "Imóvel da União" não foi informado no indicador real`, '', 'warning', () => {
      //     FrontBusiness.openModal(DetalhesIndicadorReal, {id: ficha.id});
      //   }, 'warning');
      // } else

      if (ficha.imovelUniao) {
        if (ato.tipoServico.opcoes.tipoTransacaoDoi !== 'NENHUM' && (ato.doi?.gerarDoi || !ato.tipoServico?.opcoes?.doiOpcional)) {
          if (Utils.isEmptyNullOrUndefined(ato.doi?.tipoTransacaoDoitu)) {
            criarErro("IMÓVEL DA UNIÃO [DOITU] - Necessário preencher o campo “Tipo de Transação”", null, 'erro');
          }
          let msgErroWarning = ato.doi?.gerarDoi || !ato.tipoServico?.opcoes?.doiOpcional ? 'erro' : 'warning';
          if (Utils.isEmptyNullOrUndefined(ficha.numeroRipSpu)) {
            criarErro(`IMÓVEL DA UNIÃO [DOITU] - Necessário preencher o campo “Número RIP SPU" no indicador real`, '', msgErroWarning, () => {
              FrontBusiness.openModal(DetalhesIndicadorReal, {id: ficha.id});
            }, 'erro');
          }
          if (Utils.isEmptyNullOrUndefined(ato.numeroCat)) {
            criarErro(`IMÓVEL DA UNIÃO [DOITU] - Necessário preencher o campo "Número da CAT"`, '', msgErroWarning, null, 'erro');
          }
        }
      }

      await SimulacaoAtoBusiness.simulacaoRestricao(ficha, ato);
    }

  }

}
